/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const DiscountScope = {
    Class: 'Class',
    Student: 'Student',
    Family: 'Family'
} as const;
export type DiscountScope = typeof DiscountScope[keyof typeof DiscountScope];


export function instanceOfDiscountScope(value: any): boolean {
    for (const key in DiscountScope) {
        if (Object.prototype.hasOwnProperty.call(DiscountScope, key)) {
            if (DiscountScope[key as keyof typeof DiscountScope] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DiscountScopeFromJSON(json: any): DiscountScope {
    return DiscountScopeFromJSONTyped(json, false);
}

export function DiscountScopeFromJSONTyped(json: any, ignoreDiscriminator: boolean): DiscountScope {
    return json as DiscountScope;
}

export function DiscountScopeToJSON(value?: DiscountScope | null): any {
    return value as any;
}

export function DiscountScopeToJSONTyped(value: any, ignoreDiscriminator: boolean): DiscountScope {
    return value as DiscountScope;
}

